import { render, staticRenderFns } from "./CoworkerSearch.vue?vue&type=template&id=4cddd034&scoped=true"
import script from "./CoworkerSearch.vue?vue&type=script&lang=js"
export * from "./CoworkerSearch.vue?vue&type=script&lang=js"
import style0 from "./CoworkerSearch.vue?vue&type=style&index=0&id=4cddd034&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cddd034",
  null
  
)

export default component.exports